import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { apiRequest } from "./apiClient";

export async function deleteAccount() {
  await apiRequest("Account", { method: "DELETE" });
  await signOut(auth);
}
